import { DocumentDto } from '@app/generated/model';
import { DocumentActions, DocumentActionTypes } from '@dwo/actions';

const savedPages = JSON.parse(sessionStorage.getItem('documentPages') || '{}');
const savedOpenedTabIds = JSON.parse(sessionStorage.getItem('openedTabIds') || '{}');
const savedActiveTabId = JSON.parse(sessionStorage.getItem('activeTabId') || '{}');

export const initialState: DocumentsState = {
  documents: [],
  documentPages: savedPages,
  openedTabIds: savedOpenedTabIds,
  activeTabId: savedActiveTabId,
};

export interface DocumentsState {
  documents: DocumentDto[];
  documentPages: { [username: string]: { [docId: string]: number } };
  openedTabIds: { [username: string]: string[] };
  activeTabId: { [username: string]: string | null };
}

export function documentsReducer(state: DocumentsState = initialState, action: DocumentActions): DocumentsState {
  switch (action.type) {
    case DocumentActionTypes.LoadDocumentsSuccess:
      return {
        ...state,
        documents: action.documents,
      };
    case DocumentActionTypes.LoadDocumentPage: {
      const username = action.username;
      return {
        ...state,
        documentPages: {
          ...state.documentPages,
          [username]: {
            ...(state.documentPages[username] || {}),
            [action.docId]: action.page,
          },
        },
      };
    }
    case DocumentActionTypes.LoadDocumentPages: {
      const username = action.username;
      return {
        ...state,
        documentPages: {
          ...state.documentPages,
          [username]: { ...action.pages },
        },
      };
    }
    case DocumentActionTypes.LoadOpenedTabs: {
      const username = action.username;
      return {
        ...state,
        openedTabIds: {
          ...state.openedTabIds,
          [username]: action.openedTabIds,
        },
      };
    }
    case DocumentActionTypes.LoadActiveTab: {
      const username = action.username;
      return {
        ...state,
        activeTabId: {
          ...state.activeTabId,
          [username]: action.activeTabId,
        },
      };
    }
    default:
      return {
        ...state,
      };
  }
}
